// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader-container-wrapper {
    top: 0;
    left: 0;
    background-color: var(--light_grey);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    z-index: 1000;
}

.loader-container {
    position: fixed;
}

.loader-component-container {
    position: absolute;
}`, "",{"version":3,"sources":["webpack://./src/components/loaders/Loader.css"],"names":[],"mappings":"AAAA;IACI,MAAM;IACN,OAAO;IACP,mCAAmC;IACnC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".loader-container-wrapper {\n    top: 0;\n    left: 0;\n    background-color: var(--light_grey);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    opacity: 0.5;\n    z-index: 1000;\n}\n\n.loader-container {\n    position: fixed;\n}\n\n.loader-component-container {\n    position: absolute;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
